import { css, Global } from "@emotion/react";
import styled from "@emotion/styled";
import { black, lightGreen, lightGrey3, white } from "@stepfinance/react";
import type { SelectProps } from "antd";
import { Select } from "antd";
import type { RefSelectProps, SelectValue } from "antd/lib/select";
import type { ReactElement, Ref } from "react";
import React from "react";

import { ReactComponent as ArrowDown } from "../../assets/chevron.svg";

export const StyledSelect = <VT extends SelectValue = SelectValue>(
  props: SelectProps<VT> & {
    ref?: React.Ref<RefSelectProps> | undefined;
  },
) => {
  const StyledSelect = styled<SelectType<VT>>(Select)`
    width: 100%;
    .ant-select-selector {
      background: ${black} !important;
      border-radius: 2px;

      padding: 8px 12px;
      border: none;
      font-size: 14px;
      color: ${white};
    }
    .ant-select-arrow {
      color: ${white};
      .anticon-down svg path {
        stroke: ${white};
        stroke-width: 50;
      }
    }
  `;
  return (
    <>
      <Global
        styles={css`
          .step-dropdown {
            .ant-select-item-option {
              background: ${black};
            }
            .rc-virtual-list-scrollbar-show {
              width: 6px;
              background: ${lightGrey3};
              .rc-virtual-list-scrollbar-thumb {
                width: inherit;
                background: ${lightGreen} !important;
              }
            }
          }
        `}
      />
      <StyledSelect suffixIcon={<ArrowDown />} dropdownClassName="step-dropdown" {...props} />
    </>
  );
};

export interface SelectType<VT extends SelectValue = SelectValue> {
  (
    props: SelectProps<VT> & {
      ref?: Ref<RefSelectProps> | undefined;
    },
  ): ReactElement;
}
